const routers =[
    {
        path: '/about_us',
        name: 'about_us',
        meta: {
            exp: '关于我们',
            requireAuth: false
        },
        component: () => import('@/views/about_us/index.vue'),
        children: [
            {
                path: '/about_us',
                name: 'about',
                meta: {
                    exp: '关于我们',
                    requireAuth: false
                },
                component: () => import('@/views/about_us/about/index.vue'),
            },
            {
                path: '/breaking_news',
                name: 'breaking_news',
                meta: {
                    exp: '大事件',
                    requireAuth: false
                },
                component: () => import('@/views/about_us/breaking_news/index.vue'),
            }
        ],
    },
    {
		path: '/about_us_park_detail',
		name: 'about_us_park_detail',
		meta: {
			exp: '关于我们',
			requireAuth: false
		},
		component: () => import('@/views/investment_info/park_detail/index.vue')
	},
    {
        path: '/user_protocol',
        name: 'user_protocol',
        meta: {
            exp: '用户协议',
            requireAuth: false
        },
        component: () => import('@/views/about_us/agreement/user_protocol.vue'),
        children: [],
    },
    {
        path: '/privacy_clauset',
        name: 'privacy_clauset',
        meta: {
            exp: '隐私声明',
            requireAuth: false
        },
        component: () => import('@/views/about_us/agreement/privacy_clauset.vue'),
        children: [],
    },

]
export default routers